import { Injectable } from '@angular/core';
import { DataRelation } from '@osos/shared/api';
import { DataRelationPresenterModel } from '@osos/shared/types';
import { FactoryBase } from '../../bases/factory/factory-base';
import { DataRelationsParserV1Service } from '../../parsers/data-relations-pareser/data-relations-parser-v1.service';
import { ParserFactory } from '../../services';

@Injectable()
export class DataRelationsFactoryService extends FactoryBase<
  DataRelation,
  DataRelationPresenterModel
> {
  constructor(
    parserFactory: ParserFactory,
    parser_v1: DataRelationsParserV1Service,
  ) {
    super(parserFactory);
    // register the related parsers within the parser factory:
    parserFactory.register(parser_v1);
  }
  createDataModel(presenter: DataRelationPresenterModel): DataRelation {
    const parser = this.getParser(
      DataRelation,
      DataRelationPresenterModel,
      presenter.specificationVersion,
    );
    const result = parser.getDataModel(presenter);

    return result;
  }

  createPresenterModel(model: DataRelation): DataRelationPresenterModel {
    const parser = this.getParser(
      DataRelation,
      DataRelationPresenterModel,
      model.specificationVersion,
    );
    const result = parser.getPresenterModel(model);
    return result;
  }
}
